import { useState, useEffect, useContext } from "react";
import { VStack, Select } from "@chakra-ui/react";
import UserTable from "../components/User/UserTable";
import { axiosInstance } from "../Axios";
import { CityContext } from "../context/CityContext";
import { useOutletContext } from "react-router-dom";

const Merchants = () => {
  const [merchants, setMerchants] = useState([]);
  const [city, setCity] = useState("");
  const { cities } = useContext(CityContext);
  const { searchInput } = useOutletContext();

  const fetchMerchants = async () => {
    try {
      const merchants = await axiosInstance.get(
        "/admin/merchants?city=" + city
      );
      setMerchants(merchants.data.list);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchMerchants();
  }, [city]);

  const filteredmerchants = merchants.filter((user) =>
    user.name.toLowerCase().includes(searchInput.toLowerCase())
  );

  return (
    <VStack
      bg={"#FFF"}
      h="full"
      m={{base:0,tablet:10}}
      borderRadius={"20px"}
      alignItems={"start"}
      p={10}
      w={{ base: "100%", tablet: "1038px" }} // Responsive width
      overflowX="hidden" 
    >
      <Select
        boxShadow={"0px 2px 6px rgba(0,0,0,0.25)"}
        border={"none"}
        w="auto"
        placeholder="City"
        fontWeight={"medium"}
        fontFamily={"Barlow"}
        onChange={(e) => setCity(e.target.value)}
      >
        {cities.length > 0 ? (
                        cities.map((city) => (
                        <option key={city.cityId} value={city.cityName}>
                            {city.cityName}
                        </option>
                    ))
                    ) : (
                        <option disabled>Loading cities...</option>
                    )}
      </Select>
      <UserTable users={filteredmerchants} />
    </VStack>
  );
};

export default Merchants;
